var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('f-card',_vm._l((_vm.lastMonths),function(item,index){return _c('div',{key:index},[_vm._v(" "+_vm._s(item.date)+": "+_vm._s(item.have ? "Ok" : _vm.$t('labels.notSend'))+" ")])}),0)}
var staticRenderFns = []

export { render, staticRenderFns }